<template>
  <div>
    <alert ref="alert" />
    <div v-if="showSpinner" class="loader-wrapper">
      <div class="loader"></div>
    </div>
    <b-row class="mt-2 mb-2">
      <b-col cols="2">
        <b-form-group label="Deal Name" label-for="dealName" class="text-left" label-class="font-weight-bold">
          <b-form-select id="dealName" v-model="dealName" :options="dealNames"/>
        </b-form-group>
      </b-col>
      <b-col cols="2">
        <b-form-group label="Group By" label-for="gr_fi" class="text-left" label-class="font-weight-bold">
          <b-form-select id="gr_fi" v-model="groupByField">
            <option value="Servicer">Servicer</option>
            <option value="State">State</option>
            <option value="PropType">Property Type</option>
            <option value="LoanPurpose">Loan Purpose</option>
            <option value="Seller">Seller</option>
            <option value="MtgInsType" v-if="isCasDeal">Mortgage Insurance Type</option>
            <option value="ForbearanceFlag" v-if="isCasDeal">Forberance Flag</option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="4" class="text-left">
        <b-btn variant="primary" class="pos_bottom" @click="loadCollateralReport">Run Query</b-btn>
        <b-btn variant="primary" class="pos_bottom left" @click="loadCollateralHistory">History</b-btn>
      </b-col>
    </b-row>
    <collateral-history
      :dealName="dealNameRes"
      :collateralHistory="collateralHistory"
      @loadCollateralHistory="loadCollateralHistory"/>
    <!-- <collateral-remit-history
      :history="collateralRemitHistory"
      @load="loadCollateralRemitHistory"/> -->
    <collateral-report
      :dealName="dealNameRes"
      :groupByField="groupByFieldRes"
      :collateralReport="collateralReport"/>
    </div>
</template>

<script>
import service from '../../services/HttpRequestService';
import CollateralHistory from './CollateralHistory';
import CollateralReport from './CollateralReport';
import CollateralRemitHistory from './CollateralRemitHistory';
import formatter from '../../utilities/Formatter';
import Alert from '../Alert';
import { TRACE_ERROR } from '../../constants';

export default {
  data() {
    return {
      dealName: '',
      dealNames: [],
      groupByField: 'Servicer',
      dealNameRes: '',
      groupByFieldRes: '',
      collateralHistory: [],
      collateralReport: [],
      collateralRemitHistory: [],
      showSpinner: false
    };
  },
  computed: {
    isCasDeal() {
      return this.dealName.startsWith('CAS');
    }
  },
  async created() {
    this.showSpinner = true;
    try {
      let res = await service.getDealsNames();
      this.dealNames = res.data.filter(name => name.startsWith('STACR') || name.startsWith('CAS'));
      this.dealNames = res.data.filter(
        name => name.startsWith('STACR') || name.startsWith('CAS') || name.startsWith('ITL')
      );
      let selectedDeal = this.$store.getters.dealName;
      if (
        selectedDeal.startsWith('STACR') ||
        selectedDeal.startsWith('CAS') ||
        selectedDeal.startsWith('ITL')
      ) {
        this.dealName = selectedDeal;
      } else {
        this.dealName = this.dealNames[0];
      }
    } catch (err) {
      this.$refs.alert.showAlert('danger', err.response.data.Message);
    }
    this.showSpinner = false;
  },
  methods: {
    async loadCollateralHistory() {
      this.showSpinner = true;
      this.collateralReport = [];
      try {
        let res = await service.getCollateralHistory(this.dealName);
        this.collateralHistory = formatter.formatDataInArray(
          res.data.CollateralHistory,
          ['CurrentBalance', 'OriginalBalance'],
          ['Date'],
          ['Delinquency30', 'Delinquency60', 'Delinquency90Plus'],
          []
        );
        for (let row of this.collateralHistory) {
          row.LoansCount = formatter.formatDollarValue(row.LoansCount, 0);
        }
        this.dealNameRes = this.dealName;
      } catch (err) {
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      }
      this.showSpinner = false;
    },
    async loadCollateralReport() {
      this.showSpinner = true;
      this.collateralHistory = [];
      try {
        let res = await service.getCollateralReport(this.dealName, this.groupByField);
        this.collateralReport = formatter.formatDataInArray(
          res.data.CollateralHistory,
          ['CurrentBalance', 'OriginalBalance'],
          [],
          ['Delinquency30', 'Delinquency60', 'Delinquency90Plus'],
          []
        );
        for (let row of this.collateralReport) {
          row.LoansCount = formatter.formatDollarValue(row.LoansCount, 0);
        }
        this.groupByFieldRes = this.groupByField;
        this.dealNameRes = this.dealName;
      } catch (err) {
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      }
      this.showSpinner = false;
    },
    async loadCollateralRemitHistory() {
      this.showSpinner = true;
      try {
        let res = await service.getCollateralRemitHistory(this.$store.getters.dealName);
        this.collateralRemitHistory = formatter.formatDataInArray(
          res.data.CollateralRemitHistory,
          ['CurrentBalance'],
          ['Date'],
          [
            'Cpr1Mo',
            'CurrentLossPct',
            'CumulatedLossPct',
            'Delinquency30Pct',
            'Delinquency60Pct',
            'Delinquency90PlusPct',
            'ModifiedBalancePct'
          ],
          ['Factor']
        );
      } catch (err) {
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      }
      this.showSpinner = false;
    }
  },
  components: {
    CollateralHistory,
    CollateralReport,
    CollateralRemitHistory,
    Alert
  }
};
</script>

<style lang="scss" scoped>
.pos_bottom {
  position: absolute;
  bottom: 1rem;

  &.left {
    left: 110px;
  }
}
</style>
